import { render, staticRenderFns } from "./AnswerLabel.vue?vue&type=template&id=a442c424&scoped=true"
import script from "./AnswerLabel.vue?vue&type=script&lang=js"
export * from "./AnswerLabel.vue?vue&type=script&lang=js"
import style0 from "./AnswerLabel.vue?vue&type=style&index=0&id=a442c424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a442c424",
  null
  
)

export default component.exports